import React from "react";

export default function JumbotronMobil() {
    return (
        <section className="custom-section2 py-5">
        </section>
    )
}
